/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit': {
    width: 16,
    height: 16,
    viewBox: '0 0 19.56 19.56',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M16.55 9.78v7.52A1.51 1.51 0 0 1 15 18.8H2.26a1.51 1.51 0 0 1-1.51-1.5V4.51A1.51 1.51 0 0 1 2.26 3h7.52"/><path pid="1" class="cls-1" d="M10.4 12.7l-.95.95a1.12 1.12 0 0 1-.58.31l-3.54.71-.44-.44.71-3.54a1.13 1.13 0 0 1 .31-.58l8.62-8.62A2.5 2.5 0 0 1 18.07 5l-5.19 5.19"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/edit.js